<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar color="info" size="120px" dark>
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
  <v-flex pa-1 xs12 sm12 md12>
                <v-card>
                  <v-card color="grey lighten-5" flat="">
                    <v-card-actions>
            <v-layout wrap>
              <div class="flex md12">
                <v-autocomplete tabindex="1" label="Cari Seçiniz" :color="color" clearable append-icon="search"
                  :loading="loading" :items="state" item-text="text" cache-items="" item-value="id" :search-input.sync="search"
                  v-model="MusteriPersonel.Cari.Kod"></v-autocomplete>
              </div>
              <div class="flex md6">
                <div v-show="codegorunum === true ">
                  <v-text-field label="Sirket Kodu" tabindex="2" :color="color" hide-details="" v-model="MusteriPersonel.SirketAdi"
                    :error-messages="errors.collect('bankakod')" v-validate="'required'" data-vv-name="bankakod"
                    required>
                  </v-text-field>
                </div>

                <v-text-field label="Masraf Yeri" :color="color" tabindex="3" hide-details="" v-model="MusteriPersonel.MasrafYeri"
                  :error-messages="errors.collect('bankaadi')" v-validate="'required'" data-vv-name="bankaadi" required>
                </v-text-field>
                <v-text-field label="Sicil No" hide-details="" v-model="MusteriPersonel.SicilNo" :color="color"></v-text-field>
                <v-text-field label="Adı" hide-details="" :color="color" v-model="MusteriPersonel.Adi"></v-text-field>
                <v-text-field label="Soyadı" hide-details="" v-model="MusteriPersonel.Soyadi" :color="color"></v-text-field>
                <v-text-field label="Çalışma Yeri" hide-details="" v-model="MusteriPersonel.CalismaYeri" :color="color"></v-text-field>
                <v-text-field label="Bölüm" hide-details="" v-model="MusteriPersonel.Bolum" :color="color"></v-text-field>
              </div>

              <div class="flex md6" style="padding-left:2px;">
                <v-text-field label="İç Seyahat" hide-details="" v-model="MusteriPersonel.IcSeyahat" :color="color"></v-text-field>
                <v-text-field label="Dış Seyahat" hide-details="" v-model="MusteriPersonel.DisSeyahat" :color="color"></v-text-field>
                <v-text-field label="İş Alanı" hide-details="" :color="color" v-model="MusteriPersonel.IsAlani"></v-text-field>
                <v-text-field label="Sipariş" hide-details="" :color="color" v-model="MusteriPersonel.Siparis"></v-text-field>
                <v-text-field label="E-Mail" hide-details="" :color="color" v-model="MusteriPersonel.Email"></v-text-field>
                <v-text-field label="Telefon" hide-details="" :color="color" v-model="MusteriPersonel.Tel"></v-text-field>
              </div>

              <div class="flex md12">

                <v-checkbox disabled="" label="Müşteri/Personel Açık" v-model="MusteriPersonel.KapatAc"></v-checkbox>

              </div>


            </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
  </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">

              <v-btn id="bsil" color="blue darken-1" flat @click="musteriackapa()">Müşteri / Personel Aç Kapa</v-btn>
              <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">Güncelle</v-btn>
            </div>

            <v-btn color="blue darken-1" flat @click="vazgec()">Vazgeç</v-btn>
            <div v-show="k === true">
              <v-btn id="bkaydet" color="blue darken-1" flat @click="Kaydet()">Kaydet</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar color="info" size="120px" dark>
        <v-toolbar-title class="baslikfont">Müşteri Personel Bilgileri</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
        <v-btn hidden="xs" flat @click="ekle()"> <span class="hidden-sm-and-down"> Müşteri Personel Ekle </span>
          <v-icon right dark>add_box</v-icon>
        </v-btn>
      </v-toolbar>
    </v-layout>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items" :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item.ID)" item>
            <td class="text-xs-left">{{ props.item.ID }}</td>
            <td class="text-xs-left">{{ props.item.SirketAdi }}</td>
            <td class="text-xs-left">{{ props.item.MasrafYeri }}</td>
            <td class="text-xs-left">{{ props.item.SicilNo }}</td>
            <td class="text-xs-left">{{ props.item.Adi }}</td>
            <td class="text-xs-left">{{ props.item.Soyadi }}</td>
            <td class="text-xs-left">{{ props.item.CalismaYeri }}</td>
            <td class="text-xs-left">{{ props.item.Bolum }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
        </v-alert>
      </v-data-table>
    </v-card>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        headers: [{
            text: 'ID',
            value: 'ID'
          },

          {
            text: 'Şirket Adı',
            value: 'SirketAdi'
          },
          {
            text: 'Masraf Yeri',
            value: 'MasrafYeri'
          },
          {
            text: 'Sicil No',
            value: 'SicilNo'
          },
          {
            text: 'Adı',
            value: 'Adi'
          },
          {
            text: 'Soyadı ',
            value: 'Soyadi'
          },
          {
            text: 'Çalışma Yeri ',
            value: 'CalismaYeri'
          },
          {
            text: 'Bölüm ',
            value: 'Bolum'
          }

        ],
        loading: false,
        color: 'orange darken-4',
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,

        MusteriPersonel: {
          ID: '',
          SirketKodu: '',
          SirketAdi: '',
          MasrafYeri: '',
          SicilNo: '',
          Adi: '',
          Soyadi: '',
          CalismaYeri: '',
          Bolum: '',
          IcSeyahat: '',
          DisSeyahat: '',
          IsAlani: '',
          Siparis: '',
          Cari: {
            Kod: ''
          },
          KapatAc: false,
          Email: '',
          Tel: '',
        },




        cari: '',
        state: [],
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        progress: false,
        dictionary: {
          custom: {
            bankakod: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            bankaadi: {
              required: () => 'Bu alan boş bırakılamaz',
            }
          }
        }
      }
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      Getir(v) {
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Müşteri Personel Bilgileri Güncelle'

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          CompanyCode: credentials.SirketKodu,
          CustomerPersonnelID: v

        }
        this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelGet', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          var seciliitems = [{
            text: response.body.Cari.Unvan + '-' + response.body.Cari.Kod,
            id: response.body.Cari.Kod
          }]
          this.state = seciliitems
          this.MusteriPersonel.Cari.Kod = response.body.Cari.Kod



          this.MusteriPersonel = response.body

        })
      },
      musteriackapa: musteriackapa,
      ekle: ekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      carigetir: carigetir,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    vazgec: vazgec
  }


  function vazgec() {
    this.dialog = false
    this.search = ''
  }


  function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.state = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }


  function Kaydet() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params1 = {
          CompanyCode: credentials.SirketKodu
        }

        this.MusteriPersonel.SirketKodu = credentials.SirketKodu

        var params = this.MusteriPersonel

        this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
              this.text1 = 'Kayıt işlemi tamamlandı.'
              this.snackbar = true
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })

          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      }
    })
  }

  function ekle() {

    this.MusteriPersonel.ID = ''
    this.MusteriPersonel.SirketKodu = ''
    this.MusteriPersonel.SirketAdi = ''
    this.MusteriPersonel.MasrafYeri = ''
    this.MusteriPersonel.SicilNo = ''
    this.MusteriPersonel.Adi = ''
    this.MusteriPersonel.Soyadi = ''
    this.MusteriPersonel.CalismaYeri = ''
    this.MusteriPersonel.Bolum = ''
    this.MusteriPersonel.IcSeyahat = ''
    this.MusteriPersonel.DisSeyahat = ''
    this.MusteriPersonel.IsAlani = ''
    this.MusteriPersonel.Siparis = ''
    this.MusteriPersonel.Cari.Kod = ''
    this.MusteriPersonel.KapatAc = false
    this.MusteriPersonel.Email = ''
    this.MusteriPersonel.Tel = ''

    this.dialog = true
    this.dialog_baslik = 'Müşteri Personel Bilgi Girişi'
    this.m = false
    this.k = true
    this.codegorunum = true
    this.$validator.reset()

  }

  function beforeMount() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      SirketKodu: credentials.SirketKodu
    }
    this.progress = true
    this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }

  function musteriackapa() {
    if (window.confirm('Müşter/Personel\'i açmak veya kapatmak istediğinize eminmisiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      this.MusteriPersonel.SirketKodu = credentials.SirketKodu
      var params = {
        CustomerPersonnelID: this.MusteriPersonel.ID,
        CloseOpen: !(this.MusteriPersonel.KapatAc)
      }



      this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelCloseOpen', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
          var params1 = {
            SirketKodu: credentials.SirketKodu
          }
          this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.search = response.body.Tarih
            this.dialog = false


          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        }
      }, (response) => {
        if (response.status === 0) {
          this.progress = false
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.progress = false
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.MusteriPersonel.SirketKodu = credentials.SirketKodu
        var params = this.MusteriPersonel


        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = 'Güncelleme işlemi tamamlandı'
            this.snackbar = true
            var params1 = {
              SirketKodu: credentials.SirketKodu
            }


            this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>